import { render } from "./ReliefMap.vue?vue&type=template&id=37be74f8"
import script from "./ReliefMap.vue?vue&type=script&lang=js"
export * from "./ReliefMap.vue?vue&type=script&lang=js"

import "./ReliefMap.vue?vue&type=style&index=0&id=37be74f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__